import React from 'react';
import { PaperTitle, Button, DotNotification, PaperMessage } from 'virtues-bootstrap';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import { map } from 'ramda';

import { REGISTERED } from 'constants/observationStatuses';
import SidebarReportItem from 'components/SidebarReportItem';

import s from './styles.module.scss';

const SidebarRecentReports = ({ data, match, t, isAvailableCreateReport, location, isDoctor }) => {
  const isAvailableReports = Boolean(data.length);
  const onCreationRoute = /\/patient\/(.*)\/transmission-report\/new/.test(location.pathname);
  return (
    <>
      <div className={s.reportListHeader}>
        <PaperTitle className={s.paperTitle}>{t('reports.recentReports')}</PaperTitle>
      </div>
      {!isAvailableReports && (
        <PaperMessage className={s.noReportsMsg}>{t('reports.noReports')}</PaperMessage>
      )}
      <div className={s.reportsList}>
        {map(
          ({ date, id, status }) => (
            <SidebarReportItem key={id} baseUrl={match.url} id={id}>
              <>
                {isDoctor && status === REGISTERED && (
                  <DotNotification className={s.notificationDot} />
                )}
                {date}
              </>
            </SidebarReportItem>
          ),
          data,
        )}
      </div>
      {(isAvailableCreateReport || isAvailableReports) && (
        <div className={s.viewAllContainer}>
          {isAvailableReports && (
            <Button
              className={s.button}
              component={Link}
              to={`/patient/${match.params.id}/reports`}
              variant="primary"
              stretch
              outlined
            >
              {t('reports.viewAllReports')}
            </Button>
          )}
          {isAvailableCreateReport && !onCreationRoute && (
            <Button
              className={s.button}
              component={Link}
              to={`/patient/${match.params.id}/transmission-report/new`}
              variant="secondary"
              stretch
            >
              {t('reports.createNewReport')}
            </Button>
          )}
        </div>
      )}
    </>
  );
};

SidebarRecentReports.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
    }),
  ).isRequired,
  location: ReactRouterPropTypes.location.isRequired,
  match: ReactRouterPropTypes.match.isRequired,
  t: PropTypes.func.isRequired,
  isAvailableCreateReport: PropTypes.bool.isRequired,
  isDoctor: PropTypes.bool.isRequired,
};

export default withTranslation()(SidebarRecentReports);
